<template>
  <div v-loading="loading" class="formData Taxi">
    <InternationalBase
      v-if="form && form.application"
      ref="interbase"
      :application="form.application"
      :appLanguage="appLanguage"
      :showDiffTips="showDiffTips"
    ></InternationalBase>
    <FormBox
      v-if="
        $route.meta.search || (spCode == '00' && !$route.query.authentication)
      "
      v-show="
        $route.meta.search ||
        (form &&
          form.application &&
          form.application.cert &&
          form.application.agree != false)
      "
      :title="$t('message.DataRegistration.International.submitTitle')"
    >
      <div
        v-for="(item, i) in documentType.filter((ele) =>
          $route.meta.search
            ? ele.documentType.code !== '5022' &&
              ele.documentType.code !== '5032'
            : ele.code !== '5022' && ele.code !== '5032'
        )"
        :key="i"
      >
        <InternationalFiles
          :data="$route.meta.search ? item.documentType : item"
          :follow="item"
          @change="handleChange($event, item.id)"
          @removeFile="removeFile(item.id)"
        ></InternationalFiles>
      </div>
    </FormBox>

    <!-- 錯誤信息 -->
    <div
      v-if="!$route.meta.search && spCode && spCode != '00'"
      class="ps_msgBox"
    >
      <div class="ps_msg_failed">
        <div class="failed_text">
          <i class="el-icon-warning"></i>
          <span>{{
            $t("message.DataRegistration.International.canNotApply")
          }}</span>
        </div>
        <div class="failed_reason">
          {{ $t("message.reason") }}
          {{
            (form &&
              form.application &&
              form.application[
                `spResult${
                  $i18n.locale == "ZH_TW" || $i18n.locale == "ZH_CN"
                    ? "Cn"
                    : "Pt"
                }`
              ]) ||
            ""
          }}
        </div>
      </div>
    </div>

    <!-- 面容驗證信息 -->
    <div
      class="ps_msgBox"
      id="authentication_status"
      v-if="$route.query.authentication"
    >
      <el-form :model="form">
        <el-form-item
          v-if="form.application && form.application.cheque"
          :label="$t('message.DataRegistration.International.payment_total')"
        >
          <el-input v-model="totalAmount" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.DataRegistration.International.payment_type')"
        >
          <div class="">
            <el-radio
              v-for="(item, i) in payMethod"
              :key="i"
              v-model="paymentForm.paymentType"
              :label="item.paymentChannel"
            >
              <img
                class="mpay_icon"
                :src="require(`../../../../assets/${item.icon}.png`)"
                alt=""
              />
            </el-radio>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div v-if="!$route.meta.search && spCode == '00'" class="next_btn">
      <GradientBtn
        v-if="!$route.query.authentication"
        @click="next"
        :disabled="
          form &&
          form.application &&
          form.application.cert &&
          form.application.agree === false
        "
        >{{
          $t("message.DataRegistration.International.next_check")
        }}</GradientBtn
      >
      <GradientBtn
        v-if="$route.query.authentication && $route.query.token"
        @click="pay"
        :disabled="$route.query.error"
        >{{
          $t("message.DataRegistration.International.continue_pay")
        }}</GradientBtn
      >
      <GradientBtn
        v-if="$route.query.authentication && !$route.query.token"
        @click="authenticationCheck"
        >{{ $t("message.authentication_status_no") }}</GradientBtn
      >
    </div>
    <div v-if="$route.meta.search" class="next_btn">
      <GradientBtn @click="checkSubmit" :loading="submitLoading">{{
        $t("message.check_and_submit")
      }}</GradientBtn>
    </div>
    <!-- 缴费信息弹窗 -->
    <el-dialog
      :title="$t('message.DataRegistration.International.payment_info')"
      :visible.sync="showPaymentDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="500px"
      :before-close="handlePaymentDialogClose"
      top="20vh"
      class="dialog_center_type files_dialog"
    >
      <div class="paymentDialog_content">
        <el-form :model="form">
          <el-form-item
            v-if="form.application && form.application.cheque"
            :label="$t('message.DataRegistration.International.payment_total')"
          >
            <el-input v-model="totalAmount" placeholder="" disabled></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.DataRegistration.International.payment_type')"
          >
            <div>
              <el-radio
                v-for="(item, i) in payMethod"
                :key="i"
                v-model="paymentForm.paymentType"
                :label="item.paymentChannel"
              >
                <img
                  class="mpay_icon"
                  :src="require(`../../../../assets/${item.icon}.png`)"
                  alt=""
                />
              </el-radio>
            </div>
          </el-form-item>
        </el-form>
        <div class="payment_dialog_tips">
          {{ $t("message.DataRegistration.International.payment_tips") }}
        </div>
      </div>
      <div slot="footer">
        <el-row :gutter="32">
          <el-col :xs="24" :md="12" style="margin-bottom: 10px">
            <GradientBtn
              @click="handlePaymentDialogClose"
              :disabled="submitLoading"
              >{{ $t("message.back") }}</GradientBtn
            >
          </el-col>
          <el-col :xs="24" :md="12" style="margin-bottom: 10px">
            <GradientBtn @click="handlePayment" :loading="submitLoading">{{
              $t("message.DataRegistration.International.confirm_and_pay")
            }}</GradientBtn>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <!-- 重複支付彈窗 -->
    <el-dialog
      :title="$t('message.tips')"
      :visible.sync="showRepeatDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="350px"
      :before-close="handleClose"
      top="30vh"
    >
      <div style="font-size: 16px; white-space: pre-line">
        {{ $t("message.ErrorMessage.REPEAT_PAYMENT_ERROR") }} {{ rocallTime }}
        {{ $t("message.ErrorMessage.REPEAT_PAYMENT_ERROR1") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 確認資料彈窗 -->
    <InternationalCheckDialog
      v-if="showInternationalCheckDialog && form && form.application"
      :application="form.application"
      :documentType="documentType"
      :showDiffTips="showDiffTips"
      @next="showPaymentDialog = true"
      @close="showInternationalCheckDialog = false"
    ></InternationalCheckDialog>
  </div>
</template>

<script>
import FormBox from "../components/FormBox";
import GradientBtn from "../../../../components/GradientBtn";
import InternationalBase from "../components/InternationalBase";
import InternationalFiles from "../components/InternationalFiles";
import DocumentTypeAPI from "../../../../api/DocumentTypeAPI";
import ApplicationAPI from "../../../../api/ApplicationAPI";
import DrivIntApplicationAPI from "../../../../api/DrivIntApplicationAPI";
import DrivingInternationPublicAPI from "../../../../api/DrivingInternationPublicAPI";
import IdentifyAPI from "../../../../api/IdentifyAPI";
import { resourcePath } from "../../../../api/axios";
import safpBridgeObj from "../../../../plugins/govmo-js-sdk";
import ServiceTypeConfigAPI from "../../../../api/ServiceTypeConfigAPI";
import InternationalCheckDialog from "../components/InternationalCheckDialog";

var myTime;
export default {
  components: {
    FormBox,
    GradientBtn,
    InternationalBase,
    InternationalFiles,
    InternationalCheckDialog,
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      payLoading: false,
      form: {},
      documentType: [],
      showPaymentDialog: false,
      showInternationalCheckDialog: false,
      paymentForm: {
        paymentType: null,
      },
      totalAmount: "",
      resourcePath: resourcePath,
      showRepeatDialog: false,
      rocallTime: "00:00",
      payMethod: [],
      appLanguage: null,
    };
  },
  computed: {
    fileRequiredCheck() {
      let check = true;
      const documentType = this.documentType.filter((ele) => ele.id);
      documentType.map((item) => {
        if (this.$route.meta.search) {
          if (!item.uploadFile) {
            check = false;
          }
        } else {
          if (item.required && !item.uploadFile) {
            check = false;
          }
        }
      });
      return check;
    },
    spCode() {
      const form = this.form;
      return (form && form.application && form.application.spCode) || "";
    },
    personalType() {
      return this.$store.state.personalType;
    },
    identity() {
      return (
        (this.$store.state.serviceTypeConfig &&
          this.$store.state.serviceTypeConfig.identity) ||
        null
      );
    },
    showDiffTips() {
      const application = this.form.application;
      if (!application) return false;
      const macauMobile = Number(application.macauMobile);
      const certMacauMobile = Number(application.cert.macauMoblie);
      return (
        (application.cert && macauMobile !== certMacauMobile) ||
        (application.language === "ZH_HANT" &&
          !["B", "C"].includes(application.cert.lanauage)) ||
        (application.language === "PT" &&
          !["B", "P"].includes(application.cert.lanauage))
      );
    },
  },
  methods: {
    // 下一步
    next() {
      let formBase = this.$refs["interbase"].validateForm();
      if (!formBase) {
        this.$message({
          message: this.$t("message.form_error"),
          type: "error",
        });
        return false;
      }
      if (!this.fileRequiredCheck) {
        this.$message({
          message: this.$t("message.upload_required"),
          type: "error",
        });
        return false;
      } else {
        if (
          this.identity &&
          this.personalType == "onePass" &&
          !this.$route.query.token
        ) {
          this.showInternationalCheckDialog = true;
        } else {
          this.showInternationalCheckDialog = true;
        }
      }
    },
    // 文件上傳回調
    handleChange(file, id) {
      this.documentType = this.documentType.map((item) => {
        for (let i in file) {
          if (
            this.$route.meta.search
              ? file[i].code === item.documentType.code
              : file[i].code === item.code
          ) {
            item.uploadFile = file[i].file;
          }
        }
        return item;
      });
    },
    // 關閉繳費信息彈窗
    handlePaymentDialogClose() {
      this.showPaymentDialog = false;
    },
    // 提交申請
    handlePayment() {
      let form = this.form;
      form.application = {
        ...JSON.parse(JSON.stringify(form.application)),
        ...this.$refs.interbase.myForm,
      };
      form.application.cheque.paymentChannel = this.paymentForm.paymentType;
      form.addresses = form.application.addresses || null;
      form.application.agree = true;
      delete form.application.addresses;
      delete form.application.confirmEmail;
      let formData = new FormData();
      // 表單
      formData.append(
        "form",
        new Blob([JSON.stringify(form)], {
          type: "application/json",
        })
      );
      // 處理文件
      if (this.documentType.filter((ele) => ele.id).length > 0) {
        const documentType = this.documentType.filter(
          (item) => item.uploadFile && item.id
        );
        const files = documentType.map((item) => {
          return {
            uploadFile: item.uploadFile,
            nameTc: item.nameTc,
          };
        });
        const fileValues = documentType.map((item) => {
          return {
            fileDescription: item.descriptionTc,
            fileTitle: item.nameTc,
            fileType: item.id,
          };
        });
        console.log("aaa");
        for (let i in files) {
          formData.append(
            "files",
            files[i].uploadFile,
            `${files[i].nameTc}.png`
          );
        }
        console.log("bbb");
        formData.append(
          "fileValues",
          new Blob([JSON.stringify(fileValues)], {
            type: "application/json",
          })
        );
        console.log("ccc");
      }
      this.submitLoading = true;
      DrivIntApplicationAPI.application(formData, form.application.email)
        .then((res) => {
          this.submitLoading = false;
          localStorage.setItem("drivApplication", JSON.stringify(res));
          const identity = this.identity;
          if (
            this.personalType == "onePass" &&
            !this.$route.query.token &&
            identity
          ) {
            this.$confirm(
              this.$t("message.need_authentication"),
              this.$t("message.tips"),
              {
                confirmButtonText: this.$t("message.confirm"),
                showCancelButton: false,
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                closeOnHashChange: false,
                type: "warning",
                beforeClose: (action, instance, done) => {
                  if (action === "confirm") {
                    instance.confirmButtonLoading = true;
                    // 跳轉身份識別
                    this.authenticationCheck()
                      .then(() => {
                        instance.confirmButtonLoading = false;
                      })
                      .catch((err) => {
                        instance.confirmButtonLoading = false;
                        this.$error(err);
                      });
                  } else {
                    done();
                  }
                },
              }
            );
          } else {
            this.showPaymentDialog = false;
            this.pay();
          }
          console.log(res);
        })
        .catch((err) => {
          this.submitLoading = false;
          this.$error(err);
        });
    },
    // 身份認證跳轉
    authenticationCheck() {
      return new Promise((resolve, reject) => {
        const serviceType = this.$route.meta.type;
        const identityLevel = "HIGH";
        const language = this.$t("message.lang");
        const reason = this.$t(
          "message.DataRegistration.International.authentication_reson"
        );
        const redirectUri = `${process.env.VUE_APP_SERVER_PATH}/face/${serviceType}?spNo=${this.form.application.applicationNo}`;
        this.payLoading = true;
        IdentifyAPI.getAuthorizationUrl(
          identityLevel,
          language,
          reason,
          redirectUri
        )
          .then((res) => {
            this.payLoading = false;
            const isApp = safpBridgeObj.isSupport();
            if (isApp) {
              // 一戶通APP調身份識別
              safpBridgeObj.requestIdentity({
                identity_level: identityLevel,
                authorize_url: res,
                reason: reason,
                redirect_url: redirectUri,
                success(res) {
                  //成功回調
                  this.$router.push({
                    path: `/face/${serviceType}`,
                    query: {
                      code: (res && res.code) || "",
                    },
                  });
                },
                fail(res) {
                  //失敗回調
                  if (process.env.VUE_APP_ENV !== "production") {
                    alert("error: " + JSON.stringify(res));
                  } else {
                    this.$error(res);
                  }
                },
              });
            } else {
              window.location.href = res;
            }
            resolve();
          })
          .catch((err) => {
            this.payLoading = false;
            reject(err);
            this.$error(err);
          });
      });
    },
    // 支付
    pay() {
      const serviceType = this.$route.meta.type;
      const applicationNo = this.form.application.applicationNo;
      const channel = this.paymentForm.paymentType;
      const token = this.$route.query.token || null;
      const url = `${
        this.resourcePath
      }/public/api/v1/application/driving/start/pay/${serviceType}?applicationNo=${applicationNo}&channel=${channel}${
        token ? `&token=${token}` : ""
      }`;
      this.submitLoading = true;
      DrivingInternationPublicAPI.frequency(applicationNo)
        .then(() => {
          this.submitLoading = false;
          if (this.$store.state.isApp) {
            this.$router.push({
              path: "/way",
              query: {
                url: url,
              },
            });
          } else {
            window.location.href = url;
          }
        })
        .catch((err) => {
          this.submitLoading = false;
          // 重複支付提示
          if (err.code == "REPEAT_PAYMENT_ERROR") {
            this.ComputetTime({
              currentTime: this.$formatDate(
                new Date().toISOString(),
                "yyyy-MM-dd HH:mm:ss"
              ),
              formatCreateTime: err.message,
            });
            this.showRepeatDialog = true;
          } else {
            // 支付超時提示
            if (err.code == "PAYMENT_CHECK_FAIL") {
              const errMsg = JSON.parse(err.message);
              this.$message({
                type: "error",
                message:
                  errMsg[
                    `failedMsg${
                      this.$i18n.locale == "ZH_TW" ||
                      this.$i18n.locale == "ZH_CN"
                        ? "Cn"
                        : "Pt"
                    }`
                  ],
              });
            } else {
              this.$error(err);
            }
          }
        });
    },
    // 關閉重複支付提示彈窗
    handleClose() {
      clearTimeout(myTime);
      this.showRepeatDialog = false;
    },
    //支付倒计时
    ComputetTime(data) {
      let st = data.currentTime.replace(/\-/g, "/"), //当前服务器时间
        ct = data.formatCreateTime.replace(/\-/g, "/"); //创建订单时间
      let ts = new Date(st).getTime(),
        tc = new Date(ct).getTime();
      let cm = 5 * 60 * 1000 - (ts - tc);
      this.runBack(cm);
    },
    // 重複支付時間計算
    runBack(cm) {
      if (cm > 0) {
        cm > 60000
          ? (this.rocallTime =
              (new Date(cm).getMinutes() < 10
                ? "0" + new Date(cm).getMinutes()
                : new Date(cm).getMinutes()) +
              ":" +
              (new Date(cm).getSeconds() < 10
                ? "0" + new Date(cm).getSeconds()
                : new Date(cm).getSeconds()))
          : (this.rocallTime =
              "00:" +
              (new Date(cm).getSeconds() < 10
                ? "0" + new Date(cm).getSeconds()
                : new Date(cm).getSeconds()));
        let _msThis = this;

        myTime = setTimeout(function () {
          cm -= 1000;
          _msThis.runBack(cm);
        }, 1000);
      } else {
        this.showRepeatDialog = false;
      }
    },
    // 確認無誤並提交（補交文件）
    checkSubmit() {
      if (!this.fileRequiredCheck) {
        this.$message({
          message: this.$t("message.upload_required"),
          type: "error",
        });
        return false;
      }
      this.$confirm(
        this.$t("message.confirm_submit_content"),
        this.$t("message.tips"),
        {
          confirmButtonText: this.$t("message.confirm"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          const serviceType = this.$route.meta.type;
          const applicationId = this.form.application.id;
          let formData = new FormData();
          // 處理文件
          if (this.documentType.length > 0) {
            const documentType = this.documentType.filter(
              (item) => item.uploadFile && item.id
            );
            const files = documentType.map((item) => {
              return {
                uploadFile: item.uploadFile,
                nameTc: item.nameTc,
              };
            });
            const fileValues = documentType.map((item) => {
              return {
                fileDescription: item.documentType.descriptionTc,
                fileTitle: item.documentType.nameTc,
                fileType: item.documentType.id,
              };
            });
            for (let i in files) {
              formData.append(
                "files",
                files[i].uploadFile,
                `${files[i].nameTc}.png`
              );
            }
            formData.append(
              "fileValues",
              new Blob([JSON.stringify(fileValues)], {
                type: "application/json",
              })
            );
          }
          this.submitLoading = true;
          DrivIntApplicationAPI.supplement(serviceType, applicationId, formData)
            .then(() => {
              this.submitLoading = false;
              this.$router.push({
                path: "/drivingPaymentResult",
                query: { search: true },
              });
            })
            .catch((err) => {
              this.submitLoading = false;
              this.$error(err);
            });
        })
        .catch(() => {
          return;
        });
    },
    // 獲取文件類型
    getDocumentType() {
      this.loading = true;
      DocumentTypeAPI.get("DRV_LIC_INTER")
        .then((res) => {
          this.loading = false;
          if (
            res.filter((item) => item.code === "5022").length > 0 &&
            res.filter((item) => item.code === "5021").length < 1
          ) {
            res.push({ code: "5021", required: true });
          }
          if (
            res.filter((item) => item.code === "5032").length > 0 &&
            res.filter((item) => item.code === "5031").length < 1
          ) {
            res.push({ code: "5031", required: true });
          }
          this.documentType = res.map((ele) => {
            ele.uploadType = ele.code === "5021" || ele.code === "5031" ? 2 : 1;
            ele.showImg = ele.code == "5031" ? true : false;
            if (ele.code === "5021") {
              ele.reverseSide =
                res.filter((item) => item.code === "5022")[0] || null;
            }
            if (ele.code === "5031") {
              ele.reverseSide =
                res.filter((item) => item.code === "5032")[0] || null;
            }
            return ele;
          });
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    // 獲取補交文件詳情
    getFollowing() {
      // this.spNo = this.$store.state.verifyForm.spNo || null;
      const spNo =
        this.$route.query.spNo || localStorage.getItem("searchSpNo") || null;
      const serviceType = this.$route.meta.type;
      this.loading = true;
      ApplicationAPI.getBySpNo(serviceType, spNo, "/driving")
        .then((data) => {
          this.loading = false;
          DrivIntApplicationAPI.getApplication(data.id)
            .then((res) => {
              this.form.application = res;
              let documents = res.documents.filter(
                (item) => item.status == "SUPPLEMENTING"
              );
              if (
                documents.filter((ele) => ele.documentType.code === "5022")
                  .length > 0 &&
                documents.filter((ele) => ele.documentType.code === "5021")
                  .length < 1
              ) {
                documents.push({
                  supplementReason: documents.filter(
                    (ele) => ele.documentType.code === "5022"
                  )[0].supplementReason,
                  documentType: { code: "5021" },
                });
              }
              if (
                documents.filter((ele) => ele.documentType.code === "5032")
                  .length > 0 &&
                documents.filter((ele) => ele.documentType.code === "5031")
                  .length < 1
              ) {
                documents.push({
                  supplementReason: documents.filter(
                    (ele) => ele.documentType.code === "5032"
                  )[0].supplementReason,
                  documentType: { code: "5031" },
                });
              }
              console.log("documents: ", documents);
              this.documentType = documents.map((ele) => {
                ele.documentType.uploadType =
                  ele.documentType.code == "5021" ||
                  ele.documentType.code == "5031"
                    ? 2
                    : 1;
                ele.documentType.showImg =
                  ele.documentType.code == "5031" ? true : false;
                if (ele.documentType.code === "5021") {
                  ele.documentType.reverseSide =
                    res.documents.filter(
                      (item) => item.documentType.code === "5022"
                    )[0].documentType || null;
                }
                if (ele.documentType.code === "5031") {
                  ele.documentType.reverseSide =
                    res.documents.filter(
                      (item) => item.documentType.code === "5032"
                    )[0].documentType || null;
                }
                return ele;
              });
            })
            .catch((err) => {
              this.loading = false;
              this.$error(err);
            });
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    // 准入
    getDrivingData() {
      const verifyForm = this.$store.state.verifyForm;
      const serviceType = this.$route.meta.type;
      this.loading = true;
      DrivIntApplicationAPI.check(
        serviceType,
        verifyForm.identType,
        verifyForm.identNo,
        verifyForm.licenseNo,
        verifyForm.spNo
      )
        .then((res) => {
          this.loading = false;
          res.application.language = this.$t("message.lang");
          this.form = res;
          this.appLanguage =
            (res.application && res.application.language) || null;
          if (res.application.cheque) {
            this.totalAmount =
              "MOP " + this.utils.thousand(res.application.cheque.totalAmount);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    // 根據spNo獲取申請資料
    getDataBySpNo(spNo) {
      if (spNo) {
        this.loading = true;
        DrivIntApplicationAPI.getBySpNo(spNo)
          .then((res) => {
            res.language = this.$t("message.lang");
            this.$set(this.form, "application", res);
            if (res.cheque) {
              this.totalAmount =
                "MOP " + this.utils.thousand(res.cheque.totalAmount);
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$error(err);
          });
      }
    },
    // 獲取支付方式
    getPayMethod() {
      const serviceType = this.$route.meta.type;
      this.loading = true;
      ServiceTypeConfigAPI.getPayMethod(serviceType)
        .then((res) => {
          this.loading = false;
          this.payMethod = res.map((ele) => {
            ele.icon = ele.paymentChannel.toLowerCase();
            ele.name = ele.paymentChannel;
            return ele;
          });
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
  },
  created() {
    if (this.$route.meta.search) {
      this.getFollowing();
    } else {
      this.getPayMethod();
      this.getDocumentType();
      if (this.$route.query.spNo) {
        this.getDataBySpNo(this.$route.query.spNo);
      } else {
        this.getDrivingData();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.formData {
  overflow: hidden;
  max-width: 1048px;
  margin: auto;
  box-shadow: 0px 2px 7px 2px rgba(0, 0, 0, 0.16);
}
.showRecord_btn {
  text-align: center;
  margin: 30px 0;
}
/deep/.el-radio__inner {
  width: 16px;
  height: 16px;
}
/deep/.el-radio__label {
  font-size: 16px;
}
.mpay_icon {
  width: auto;
  height: 50px;
  display: block;
  margin-right: 10px;
}
.paymentDialog_content,
#authentication_status {
  /deep/.el-radio {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 20px;
  }
  /deep/.el-radio__label {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  /deep/.el-form-item__label {
    float: none;
  }
}
.payment_dialog_tips {
  color: #d45661;
  font-size: 16px;
}

.ps_msgBox {
  margin-bottom: 60px;
  padding: 0 14px;
}
.gradient_btn.is-disabled {
  color: #5ba7ad;
  background: #fff;
}
#authentication_status {
  margin-bottom: 20px;
  max-width: 400px;
}
.authentication_status_no {
  color: #e54b5d;
  cursor: pointer;
  text-decoration: underline;
}
</style>